import { OccConfig } from "@spartacus/core";
import { ProductScope } from "../core/models/gonvarri-product-scope";

export const gonvarriOccProductConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        product: {
          default:
            'gonvarri/products/${productCode}?fields=DEFAULT,averageRating,volumePrices(FULL),images(FULL),classifications,manufacturer,numberOfReviews,categories(FULL),baseOptions,baseProduct,variantOptions,variantType',
          list: 'gonvarri/products/${productCode}?fields=code,purchasable,name,summary,price(formattedValue),images(DEFAULT,galleryIndex),baseProduct',
          details:
            'gonvarri/products/${productCode}?fields=volumePrices(FULL),averageRating,stock(FULL),description,availableForPickup,code,url,price(DEFAULT),numberOfReviews,manufacturer,categories(FULL),priceRange,multidimensional,tags,images(FULL)',
          promotions:
            'gonvarri/products/${productCode}?fields=potentialPromotions(description)',
          attributes: 'gonvarri/products/${productCode}?fields=classifications',
          price: 'gonvarri/products/${productCode}?fields=price(formattedValue)',
          stock: 'gonvarri/products/${productCode}?fields=stock(DEFAULT)',
          list_item:
            'gonvarri/products/${productCode}?fields=code,name,price(formattedValue),images(DEFAULT),baseProduct,stock(DEFAULT),categories(FULL)',
        },

        productReviews: 'products/${productCode}/reviews',
        productReferences:
          'products/${productCode}/references?fields=DEFAULT,references(target(images(FULL)))',
        productSearch: {
          default:
            'products/search?fields=products(categories(FULL),isPurchaseBySheet,packageWeight,price,standardLength,sheetWeight,sheetsNumber,isCustomLength,code,name,summary,configurable,configuratorType,multidimensional,price(FULL),images(DEFAULT),stock(FULL),averageRating,variantOptions,baseProduct,priceRange(maxPrice(formattedValue),minPrice(formattedValue))),facets,breadcrumbs,pagination(DEFAULT),sorts(DEFAULT),freeTextSearch,currentQuery,keywordRedirectUrl',
          carousel:
            'products/search?fields=products(code,purchasable,name,summary,price(formattedValue),stock(FULL),images(DEFAULT,galleryIndex),baseProduct)',
          carouselMinimal:
            'products/search?fields=products(code,name,price(formattedValue),stock(FULL),images(DEFAULT),baseProduct)',
        },
        productSuggestions: 'products/suggestions',
      },
    },
    loadingScopes: {
      product: {
        details: {
          include: [ProductScope.LIST, ProductScope.VARIANTS],
        },
      },
    },
  },
};
